/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import "../css/lineclamp2css.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ScrollToTopButton from "./ScrollToTopButton";
import { useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import * as XLSX from "xlsx";
import { CampaignService } from "../services/campaignService";
import CampaignDetailService from "../services/campaignDetailService";
import { useTranslation } from "react-i18next";
import LoadingScreen from "./LoadingScreen";
import "../css/swal.css";
import "../css/uploadForm.css";
import SweetAlertService from "../services/SweetAlertService";
import formErrorPopupInstance from "../utils/formValidation.js";
import { Icon, Modal } from "./ui";
import functionConstants from "../utils/functionConstants";

function CampaignDetailList() {
  const {
    getExportBdelightTemplate,
    getExportCiconvTemplate,
    getExportKdollarTemplate,
    getUploadKdollarTemplate,
    getUploadCiconvTemplate,
  } = CampaignDetailService();
  var sweetAlertService = new SweetAlertService();

  // eslint-disable-next-line no-unused-vars
  const [savedLanguage, setSaveLanguage] = useState();
  const [updateDate, setUpdateDate] = useState("");
  const [check, setCheck] = useState(true);
  const [originTotalChange, setOriginTotalChange] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const ifa = localStorage.getItem("ifa");
  const functionId = localStorage.getItem("functionId");
  const functionList = String(functionId).split(",");

  const [showModal, setShowModal] = useState(false);

  const location = useLocation();
  const state = location.state;

  // Now you can access the values passed from the previous page
  const {
    campaignHeaderId,
    campaignNameEng,
    campaignNameHk,
    campaignNameCn,
    campaignTemplate,
    latestupdateDate,
  } = state;
  const PermcampaignHeaderId = campaignHeaderId;
  const PermcampaignTemplate = campaignTemplate;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [reArrange, setReArrange] = useState("");
  const [record, setRecord] = useState(0);

  const { t, i18n } = useTranslation();

  const openModal = () => {
    setModalIsOpen(true);
  };

  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);

  const closeModal = () => {
    setFileName("");
    setFileExtension("");
    setImportedData([]);
    setModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (importedData.length < 30001) {
      if (importedData.length !== 0) {
        try {
          const loadingSwal = SweetAlertService.showLoading(
            t("loginPage.loading")
          );
          var campaignService = new CampaignService();
          await campaignService
            .detailUpload(PermcampaignHeaderId, importedData)
            .then((value) => {
              if (value.status === 200) {
                setModalIsOpen(false);
                sweetAlertService
                  .successMsg(t("campaignDetailsPage.importSuccess"))
                  .then(function () {
                    SweetAlertService.close(loadingSwal);
                    window.location.reload();
                  });
              }
            });
        } catch (error) {
          sweetAlertService.errorMsg(t("errors.error"), t("errors.failToload"));
        }
      } else {
        sweetAlertService.errorMsg(t("errors.error"), t("errors.empty"));
      }
    } else {
      sweetAlertService.errorMsg(
        t("errors.error"),
        t("errors.dataLimitTextImport")
      );
    }
  };

  const overrideStrings = {
    allItemsAreSelected: t("documentCenterPage.allItemsAreSelected"),
    clearSearch: t("documentCenterPage.clearSearch"),
    clearSelected: t("documentCenterPage.clearSelected"),
    noOptions: t("common.noRecord"),
    search: t("common.search"),
    selectAll: t("documentCenterPage.selectAll"),
    selectAllFiltered: t("documentCenterPage.selectAllFiltered"),
    selectSomeItems: t("common.search"),
  };

  const getFileType = (fileExtension) => {
    switch (fileExtension.toLowerCase()) {
      case "csv":
        return "text/csv";
      case "doc":
        return "application/msword";
      case "docx":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "ppt":
        return "application/vnd.ms-powerpoint";
      case "pptx":
        return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      case "xls":
        return "application/vnd.ms-excel";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case "pdf":
        return "application/pdf";
      case "png":
        return "image/png";
      case "jpeg":
      case "jpg":
        return "image/jpeg";
      case "gif":
        return "image/gif";
      case "txt":
        return "text/plain";
      default:
        return "application/octet-stream";
    }
  };

  const downloadTemplate = async (fileName) => {
    var campaignService = new CampaignService();
    await campaignService.downloadTemplate(fileName).then((data) => {
      const fileExtension = data.data.documentName.split(".").pop();
      const fileType = getFileType(fileExtension);

      const decodedFile = window.atob(data.data.documentBase64String);
      const byteArray = new Uint8Array(decodedFile.length);
      for (let i = 0; i < decodedFile.length; ++i) {
        byteArray[i] = decodedFile.charCodeAt(i);
      }

      const blob = new Blob([byteArray], { type: fileType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });

    // const filePath = require("../templates/" + fileName); // Modify the path to the template file

    // const link = document.createElement("a");
    // link.href = filePath;
    // link.download = fileName;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const handleUpload = (event) => {
    const loadingSwal = SweetAlertService.showLoading(t("loginPage.loading"));
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the data is in the first sheet of the Excel file
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      // Assuming the title is in the first row (index 0)
      const title = jsonData[0];

      // Define the mapping between Excel column titles and JSON property names for template 1
      const template1Mapping = getUploadKdollarTemplate;

      // Define the mapping between Excel column titles and JSON property names for template 2
      const template2Mapping = getUploadCiconvTemplate;

      let templateType = null;
      let mapping = null;

      // Check if the column titles match the expected titles for template 1 and the uploaded template matches PermcampaignTemplate
      if (
        PermcampaignTemplate === "kdollar" &&
        title.every((t) => template1Mapping.hasOwnProperty(t))
      ) {
        templateType = "Template 1";
        mapping = template1Mapping;
      }

      // Check if the column titles match the expected titles for template 2 and the uploaded template matches PermcampaignTemplate
      if (
        PermcampaignTemplate === "ciconv" &&
        title.every((t) => template2Mapping.hasOwnProperty(t))
      ) {
        templateType = "Template 2";
        mapping = template2Mapping;
      }

      if (!templateType) {
        // Handle the case when the template is not recognized or the column titles don't match
        sweetAlertService.errorMsg(
          t("errors.error"),
          t("campaignDetailsPage.importError")
        );

        return;
      }

      // Assuming the data starts from the second row (index 1)
      const importedData = jsonData
        .slice(1)
        .map((row) => {
          const dataObj = {};
          row.forEach((value, index) => {
            const columnTitle = title[index];
            const propertyName = mapping[columnTitle];
            dataObj[propertyName] = value;
          });
          return dataObj;
        })
        .filter((data) => Object.keys(data).length !== 0);

      const fileExtension = file.name.split(".").pop().toLowerCase();

      const reArrange = "fi fi-size-xl fi-" + fileExtension;
      setFileExtension(fileExtension);
      setReArrange(reArrange);
      setImportedData(importedData);
      importedData.forEach((value) => {
        if (
          value.kDollar === "" ||
          value.kDollar === null ||
          value.kDollar === undefined
        ) {
          value.kDollar = -1;
        }
        if (
          value.kDollarMembership === "" ||
          value.kDollarMembership === null ||
          value.kDollarMembership === undefined
        ) {
          value.kDollarMembership = -1;
        }
      });
      setFileName(file.name); // Store the file name
    };

    if (file) {
      reader.readAsArrayBuffer(file);
    }

    SweetAlertService.close(loadingSwal);
  };

  const options = [
    {
      label: t("campaignDetailsPage.clientNameEng"),
      value: "clientFullNameEng",
    },
    {
      label: t("campaignDetailsPage.clientNameHk"),
      value: "clientFullNameChi",
    },
    {
      label: t("campaignDetailsPage.dateOfBirthFrom"),
      value: "dateOfBirthFrom",
    },
    { label: t("campaignDetailsPage.dateOfBirthTo"), value: "dateOfBirthTo" },
    {
      label: t("campaignDetailsPage.birthdayMonth") + " (MM)",
      value: "birthdayMonth",
    },
    {
      label: t("campaignDetailsPage.firstPolicyIssueDateFrom"),
      value: "firstPolicyIssueDateFrom",
    },
    {
      label: t("campaignDetailsPage.firstPolicyIssueDateTo"),
      value: "firstPolicyIssueDateTo",
    },
    {
      label: t("campaignDetailsPage.latestIssuedPolicy"),
      value: "latestIssuedPolicy",
    },

    { label: t("campaignDetailsPage.companyName"), value: "servAgentName" },

    {
      label: t("campaignDetailsPage.agentCode"),
      value: "trCode",
    },
    { label: t("campaignDetailsPage.agentName"), value: "trNameEng" },
  ];

  const kDollarOptions = [
    { label: t("campaignDetailsPage.partyId"), value: "partyId" },
    {
      label: t("campaignDetailsPage.policyownerNameHk"),
      value: "clientFullNameChi",
    },
    {
      label: t("campaignDetailsPage.policyownerNameEng"),
      value: "clientFullNameEng",
    },
    { label: t("campaignDetailsPage.policyownerEmail"), value: "email" },
    { label: t("campaignDetailsPage.policyownerMobile"), value: "mobile" },

    {
      label: t("campaignDetailsPage.customerLanguagePreference"),
      value: "languageForCommunication",
    },
    {
      label: t("campaignDetailsPage.referencePolicyNo."),
      value: "latestIssuedPolicy",
    },
    {
      label: t("campaignDetailsPage.customerCommunication"),
      value: "communicationChannel",
    },

    {
      label: t("campaignDetailsPage.kDollarMembershipNumber"),
      value: "kDollarMembership",
    },
    {
      label: t("campaignDetailsPage.redemptionStatus"),
      value: "redemptionStatus",
    },
  ];

  const ciconvOptions = [
    {
      label: t("campaignDetailsPage.policyNumber"),
      value: "latestIssuedPolicy",
    },
    {
      label: t("campaignDetailsPage.currentPlanCode"),
      value: "currentPlanCode",
    },
    { label: t("campaignDetailsPage.title"), value: "title" },
    { label: t("campaignDetailsPage.clientName"), value: "clientFullNameEng" },
    { label: t("campaignDetailsPage.areaCode"), value: "mobileAreaCode" },
    { label: t("campaignDetailsPage.mobile"), value: "mobile" },
    { label: t("campaignDetailsPage.email"), value: "email" },
    { label: t("campaignDetailsPage.picsStatus"), value: "picsIndicator" },
    {
      label: t("campaignDetailsPage.existingCustomer"),
      value: "existingCustomer",
    },
    { label: t("campaignDetailsPage.custOrPartyId"), value: "partyId" },
    { label: t("campaignDetailsPage.regionCode"), value: "servAgentRegion" },
    {
      label: t("campaignDetailsPage.brokerCode"),
      value: "servAgentCode",
    },
    {
      label: t("campaignDetailsPage.brokerName"),
      value: "servAgentName",
    },
    {
      label: t("campaignDetailsPage.agentCode"),
      value: "trCode",
    },
    { label: t("campaignDetailsPage.agentName"), value: "trNameEng" },
    { label: t("campaignDetailsPage.brokerEmail"), value: "servAgentEmail" },
  ];

  const [selected, setSelected] = useState([]);
  const [inputs, setInputs] = useState(
    (PermcampaignTemplate === "bdelight"
      ? options
      : PermcampaignTemplate === "ciconv"
      ? ciconvOptions
      : kDollarOptions
    ).map((option) => ({ value: "" }))
  );
  const [inputValue, setInputValue] = useState(
    (PermcampaignTemplate === "bdelight"
      ? options
      : PermcampaignTemplate === "ciconv"
      ? ciconvOptions
      : kDollarOptions
    ).map((option) => ({ value: "" }))
  );

  const handleSelect = (selectedOption) => {
    setSelected(selectedOption);
  };

  const handleCancel = (optionToRemove) => {
    const newSelected = selected.filter(
      (option) => option.value !== optionToRemove.value
    );
    setSelected(newSelected);
    const inputBox = document.getElementById(`input_${optionToRemove.value}`);
    if (inputBox) {
      inputBox.value = "";
      handleInputChange(optionToRemove, "");
    }
    if (newSelected.length === 0) {
      handleResetChange(
        PermcampaignHeaderId,
        savedLanguage === "en"
          ? campaignNameEng
          : savedLanguage === "cn"
          ? campaignNameCn
          : campaignNameHk,
        PermcampaignTemplate
      );
    } else {
      setRecord(record + 1);
    }
  };

  useEffect(() => {
    // This effect will run whenever selected, inputs, or other relevant state variables change.
    if (record !== 0) {
      handleCampaignChange(
        PermcampaignHeaderId,
        savedLanguage === "en"
          ? campaignNameEng
          : savedLanguage === "cn"
          ? campaignNameCn
          : campaignNameHk,
        PermcampaignTemplate
      );
    }
  }, [record]);

  const handleInputChange = (option, value) => {
    const templateOption =
      PermcampaignTemplate === "ciconv"
        ? ciconvOptions
        : PermcampaignTemplate === "kdollar"
        ? kDollarOptions
        : options;
    const newInputs = [...inputs];
    const index = templateOption.findIndex((o) => o.value === option.value);

    if (index !== -1) {
      newInputs[index].value = value;
      setInputs(newInputs);

      const inputValue = templateOption.reduce((acc, cur) => {
        const inputIndex = templateOption.findIndex(
          (o) => o.value === cur.value
        );
        acc[cur.value] =
          newInputs[inputIndex].value === ""
            ? ""
            : newInputs[inputIndex].value.trim() || null;
        return acc;
      }, {});

      setInputValue(inputValue);
    }
  };

  const [selectedValue, setSelectedValue] = useState();
  const [Page, setPage] = useState();
  const [Orderby, setOrderby] = useState("clientFullNameEng");
  const [OrderSequence, setOrderSequence] = useState("asc");
  const [campaigns, setCampaigns] = useState([]);
  const [preResult, setPreResult] = useState();
  const [nextResult, setNextResult] = useState();
  const [pagination, setPagination] = useState({});
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const [isXsMobileScreen, setXsIsMobileScreen] = useState(
    window.screen.width <= 500 || window.innerWidth <= 500 ? true : false
  );
  const [detailData, setDetailData] = useState({
    pageableParameter: {
      pageNumber: 0,
      pageSize: 10,
      orderBy: Orderby,
      orderSequence: OrderSequence,
    },
    campaignDetailParameter: {
      campaignHeaderId: PermcampaignHeaderId,
    },
  });

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setDetailData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: event.target.value,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignDetailParameter: {
        campaignHeaderId: PermcampaignHeaderId,
        ...(inputValue.clientFullNameEng && {
          clientFullNameEng: inputValue.clientFullNameEng,
        }),
        ...(inputValue.clientFullNameChi && {
          clientFullNameChi: inputValue.clientFullNameChi,
        }),
        ...(inputValue.dateOfBirthFrom && {
          dateOfBirthFrom: inputValue.dateOfBirthFrom,
        }),
        ...(inputValue.dateOfBirthTo && {
          dateOfBirthTo: inputValue.dateOfBirthTo,
        }),
        ...(inputValue.firstPolicyIssueDateFrom && {
          firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
        }),
        ...(inputValue.firstPolicyIssueDateTo && {
          firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
        }),
        ...(inputValue.latestIssuedPolicy && {
          latestIssuedPolicy: inputValue.latestIssuedPolicy,
        }),
        ...(inputValue.servAgentCode && {
          servAgentCode: inputValue.servAgentCode,
        }),
        ...(inputValue.servAgentName && {
          servAgentName: inputValue.servAgentName,
        }),
        ...(inputValue.kDollarMembership && {
          kDollarMembership: inputValue.kDollarMembership,
        }),
        ...(inputValue.redemptionStatus && {
          redemptionStatus: inputValue.redemptionStatus,
        }),
        ...(inputValue.currentPlanCode && {
          currentPlanCode: inputValue.currentPlanCode,
        }),
        ...(inputValue.title && { title: inputValue.title }),
        ...(inputValue.existingCustomer && {
          existingCustomer: inputValue.existingCustomer,
        }),
        ...(inputValue.partyId && { partyId: inputValue.partyId }),
        ...(inputValue.birthdayMonth && {
          birthdayMonth: inputValue.birthdayMonth,
        }),
        ...(inputValue.mobile && { mobile: inputValue.mobile }),
        ...(inputValue.email && { email: inputValue.email }),
        ...(inputValue.languageForCommunication && {
          languageForCommunication: inputValue.languageForCommunication,
        }),
        ...(inputValue.communicationChannel && {
          communicationChannel: inputValue.communicationChannel,
        }),
        ...(inputValue.servAgentEmail && {
          servAgentEmail: inputValue.servAgentEmail,
        }),
        ...(inputValue.mobileAreaCode && {
          mobileAreaCode: inputValue.mobileAreaCode,
        }),
        ...(inputValue.picsIndicator && {
          picsIndicator: inputValue.picsIndicator,
        }),
        ...(inputValue.trCode && {
          trCode: inputValue.trCode,
        }),
        ...(inputValue.trNameEng && {
          trNameEng: inputValue.trNameEng,
        }),
      },
    });
  };

  const handlePageChange = (event) => {
    setPage(event);
    setDetailData({
      pageableParameter: {
        pageNumber: event - 1,
        pageSize: pagination.pageSize,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignDetailParameter: {
        campaignHeaderId: PermcampaignHeaderId,
        ...(inputValue.clientFullNameEng && {
          clientFullNameEng: inputValue.clientFullNameEng,
        }),
        ...(inputValue.clientFullNameChi && {
          clientFullNameChi: inputValue.clientFullNameChi,
        }),
        ...(inputValue.dateOfBirthFrom && {
          dateOfBirthFrom: inputValue.dateOfBirthFrom,
        }),
        ...(inputValue.dateOfBirthTo && {
          dateOfBirthTo: inputValue.dateOfBirthTo,
        }),
        ...(inputValue.firstPolicyIssueDateFrom && {
          firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
        }),
        ...(inputValue.firstPolicyIssueDateTo && {
          firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
        }),
        ...(inputValue.latestIssuedPolicy && {
          latestIssuedPolicy: inputValue.latestIssuedPolicy,
        }),
        ...(inputValue.servAgentCode && {
          servAgentCode: inputValue.servAgentCode,
        }),
        ...(inputValue.servAgentName && {
          servAgentName: inputValue.servAgentName,
        }),
        ...(inputValue.kDollarMembership && {
          kDollarMembership: inputValue.kDollarMembership,
        }),
        ...(inputValue.redemptionStatus && {
          redemptionStatus: inputValue.redemptionStatus,
        }),
        ...(inputValue.currentPlanCode && {
          currentPlanCode: inputValue.currentPlanCode,
        }),
        ...(inputValue.title && { title: inputValue.title }),
        ...(inputValue.existingCustomer && {
          existingCustomer: inputValue.existingCustomer,
        }),
        ...(inputValue.partyId && { partyId: inputValue.partyId }),
        ...(inputValue.birthdayMonth && {
          birthdayMonth: inputValue.birthdayMonth,
        }),
        ...(inputValue.mobile && { mobile: inputValue.mobile }),
        ...(inputValue.email && { email: inputValue.email }),
        ...(inputValue.languageForCommunication && {
          languageForCommunication: inputValue.languageForCommunication,
        }),
        ...(inputValue.communicationChannel && {
          communicationChannel: inputValue.communicationChannel,
        }),
        ...(inputValue.servAgentEmail && {
          servAgentEmail: inputValue.servAgentEmail,
        }),
        ...(inputValue.mobileAreaCode && {
          mobileAreaCode: inputValue.mobileAreaCode,
        }),
        ...(inputValue.picsIndicator && {
          picsIndicator: inputValue.picsIndicator,
        }),
        ...(inputValue.trCode && {
          trCode: inputValue.trCode,
        }),
        ...(inputValue.trNameEng && {
          trNameEng: inputValue.trNameEng,
        }),
      },
    });
  };

  const handleCampaignChange = (campaignheaderId, campaignName, template) => {
    setDetailData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: pagination.pageSize,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignDetailParameter: {
        campaignHeaderId: campaignheaderId,
        ...(inputValue.clientFullNameEng && {
          clientFullNameEng: inputValue.clientFullNameEng,
        }),
        ...(inputValue.clientFullNameChi && {
          clientFullNameChi: inputValue.clientFullNameChi,
        }),
        ...(inputValue.dateOfBirthFrom && {
          dateOfBirthFrom: inputValue.dateOfBirthFrom,
        }),
        ...(inputValue.dateOfBirthTo && {
          dateOfBirthTo: inputValue.dateOfBirthTo,
        }),
        ...(inputValue.firstPolicyIssueDateFrom && {
          firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
        }),
        ...(inputValue.firstPolicyIssueDateTo && {
          firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
        }),
        ...(inputValue.latestIssuedPolicy && {
          latestIssuedPolicy: inputValue.latestIssuedPolicy,
        }),
        ...(inputValue.servAgentCode && {
          servAgentCode: inputValue.servAgentCode,
        }),
        ...(inputValue.servAgentName && {
          servAgentName: inputValue.servAgentName,
        }),
        ...(inputValue.kDollarMembership && {
          kDollarMembership: inputValue.kDollarMembership,
        }),
        ...(inputValue.redemptionStatus && {
          redemptionStatus: inputValue.redemptionStatus,
        }),
        ...(inputValue.currentPlanCode && {
          currentPlanCode: inputValue.currentPlanCode,
        }),
        ...(inputValue.title && { title: inputValue.title }),
        ...(inputValue.existingCustomer && {
          existingCustomer: inputValue.existingCustomer,
        }),
        ...(inputValue.partyId && { partyId: inputValue.partyId }),
        ...(inputValue.birthdayMonth && {
          birthdayMonth: inputValue.birthdayMonth,
        }),
        ...(inputValue.mobile && { mobile: inputValue.mobile }),
        ...(inputValue.email && { email: inputValue.email }),
        ...(inputValue.languageForCommunication && {
          languageForCommunication: inputValue.languageForCommunication,
        }),
        ...(inputValue.communicationChannel && {
          communicationChannel: inputValue.communicationChannel,
        }),
        ...(inputValue.servAgentEmail && {
          servAgentEmail: inputValue.servAgentEmail,
        }),
        ...(inputValue.mobileAreaCode && {
          mobileAreaCode: inputValue.mobileAreaCode,
        }),
        ...(inputValue.picsIndicator && {
          picsIndicator: inputValue.picsIndicator,
        }),
        ...(inputValue.trCode && {
          trCode: inputValue.trCode,
        }),
        ...(inputValue.trNameEng && {
          trNameEng: inputValue.trNameEng,
        }),
      },
    });
  };

  const handleResetChange = () => {
    const initialInputs = inputs.map((option) => ({
      ...option,
      value: "",
    }));
    setInputs(initialInputs);
    const inputValue = initialInputs.reduce((acc, cur) => {
      acc[cur.value] = "";
      return acc;
    }, {});
    setInputValue(inputValue);
    setSelected([]);
    setPage(1);
    setDetailData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: pagination.pageSize,
        orderBy: "clientFullNameEng",
        orderSequence: "asc",
      },
      campaignDetailParameter: {
        campaignHeaderId: PermcampaignHeaderId,
      },
    });
  };

  useEffect(() => {
    if (
      detailData.campaignDetailParameter.firstPolicyIssueDateFrom !== "" &&
      detailData.campaignDetailParameter.firstPolicyIssueDateTo !== "" &&
      detailData.campaignDetailParameter.firstPolicyIssueDateFrom >
        detailData.campaignDetailParameter.firstPolicyIssueDateTo
    ) {
      formErrorPopupInstance.addError(t("errors.invalidDateRange"));
    }

    if (
      detailData.campaignDetailParameter.dateOfBirthFrom !== "" &&
      detailData.campaignDetailParameter.dateOfBirthTo !== "" &&
      detailData.campaignDetailParameter.dateOfBirthFrom >
        detailData.campaignDetailParameter.dateOfBirthTo
    ) {
      formErrorPopupInstance.addError(t("errors.invalidDateRange"));
    }

    formErrorPopupInstance.showErrors();
    if (formErrorPopupInstance.errors.length === 0) {
      var campaignService = new CampaignService();
      campaignService
        .getValidateDetails(detailData)
        .then((value) => {
          return value.data;
        })
        .then((data) => {
          setCampaigns(data.campaignDetailList);
          setPagination(data.pagination);
          setUpdateDate(data.campaignDetailList[0].updatedDate.slice(0, -3));

          if (check) {
            setOriginTotalChange(data.pagination.totalNumberOfRecords);
            setCheck(false);
          }

          const pageNumber = parseInt(data.pagination.pageNumber);
          const pageSize = parseInt(data.pagination.pageSize);
          const totalPages = parseInt(data.pagination.totalPages);
          const totalNumberOfRecords = parseInt(
            data.pagination.totalNumberOfRecords
          );
          if (pageNumber === 0) {
            setPreResult(1);
            setNextResult(pageSize);
          } else {
            setPreResult(pageNumber * pageSize + 1);
            setNextResult((pageNumber + 1) * pageSize);
          }

          if (data.pagination.hasNext === "false" && pageNumber !== 0) {
            setPreResult((totalPages - 1) * pageSize + 1);
            setNextResult(totalNumberOfRecords);
          }
        })
        .catch((error) => console.error(error));
    }
    formErrorPopupInstance.clearErrors();
  }, [detailData, selectedValue, Page, selected]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Page]);

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
      setXsIsMobileScreen(
        window.screen.width <= 500 || window.innerWidth <= 500
      );
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
      setXsIsMobileScreen(false);
    };
  }, []);

  const handleOrder = (event) => {
    handleOrderBy(event);
    handlePostData(event);
  };

  const handleOrderBy = (event) => {
    setOrderby(event);
  };

  const handlePostData = (event) => {
    if (OrderSequence === "desc") {
      setOrderSequence("asc");
      setDetailData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "asc",
        },
        campaignDetailParameter: {
          campaignHeaderId: PermcampaignHeaderId ?? "",
          ...(inputValue.clientFullNameEng && {
            clientFullNameEng: inputValue.clientFullNameEng,
          }),
          ...(inputValue.clientFullNameChi && {
            clientFullNameChi: inputValue.clientFullNameChi,
          }),
          ...(inputValue.dateOfBirthFrom && {
            dateOfBirthFrom: inputValue.dateOfBirthFrom,
          }),
          ...(inputValue.dateOfBirthTo && {
            dateOfBirthTo: inputValue.dateOfBirthTo,
          }),
          ...(inputValue.firstPolicyIssueDateFrom && {
            firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
          }),
          ...(inputValue.firstPolicyIssueDateTo && {
            firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
          }),
          ...(inputValue.latestIssuedPolicy && {
            latestIssuedPolicy: inputValue.latestIssuedPolicy,
          }),
          ...(inputValue.servAgentCode && {
            servAgentCode: inputValue.servAgentCode,
          }),
          ...(inputValue.servAgentName && {
            servAgentName: inputValue.servAgentName,
          }),
          ...(inputValue.kDollarMembership && {
            kDollarMembership: inputValue.kDollarMembership,
          }),
          ...(inputValue.redemptionStatus && {
            redemptionStatus: inputValue.redemptionStatus,
          }),
          ...(inputValue.currentPlanCode && {
            currentPlanCode: inputValue.currentPlanCode,
          }),
          ...(inputValue.title && { title: inputValue.title }),
          ...(inputValue.existingCustomer && {
            existingCustomer: inputValue.existingCustomer,
          }),
          ...(inputValue.partyId && { partyId: inputValue.partyId }),
          ...(inputValue.birthdayMonth && {
            birthdayMonth: inputValue.birthdayMonth,
          }),
          ...(inputValue.mobile && { mobile: inputValue.mobile }),
          ...(inputValue.email && { email: inputValue.email }),
          ...(inputValue.languageForCommunication && {
            languageForCommunication: inputValue.languageForCommunication,
          }),
          ...(inputValue.communicationChannel && {
            communicationChannel: inputValue.communicationChannel,
          }),
          ...(inputValue.servAgentEmail && {
            servAgentEmail: inputValue.servAgentEmail,
          }),
          ...(inputValue.mobileAreaCode && {
            mobileAreaCode: inputValue.mobileAreaCode,
          }),
          ...(inputValue.picsIndicator && {
            picsIndicator: inputValue.picsIndicator,
          }),
          ...(inputValue.trCode && {
            trCode: inputValue.trCode,
          }),
          ...(inputValue.trNameEng && {
            trNameEng: inputValue.trNameEng,
          }),
        },
      });
    } else {
      setOrderSequence("desc");
      setDetailData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "desc",
        },
        campaignDetailParameter: {
          campaignHeaderId: PermcampaignHeaderId,
          ...(inputValue.clientFullNameEng && {
            clientFullNameEng: inputValue.clientFullNameEng,
          }),
          ...(inputValue.clientFullNameChi && {
            clientFullNameChi: inputValue.clientFullNameChi,
          }),
          ...(inputValue.dateOfBirthFrom && {
            dateOfBirthFrom: inputValue.dateOfBirthFrom,
          }),
          ...(inputValue.dateOfBirthTo && {
            dateOfBirthTo: inputValue.dateOfBirthTo,
          }),
          ...(inputValue.firstPolicyIssueDateFrom && {
            firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
          }),
          ...(inputValue.firstPolicyIssueDateTo && {
            firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
          }),
          ...(inputValue.latestIssuedPolicy && {
            latestIssuedPolicy: inputValue.latestIssuedPolicy,
          }),
          ...(inputValue.servAgentCode && {
            servAgentCode: inputValue.servAgentCode,
          }),
          ...(inputValue.servAgentName && {
            servAgentName: inputValue.servAgentName,
          }),
          ...(inputValue.kDollarMembership && {
            kDollarMembership: inputValue.kDollarMembership,
          }),
          ...(inputValue.redemptionStatus && {
            redemptionStatus: inputValue.redemptionStatus,
          }),
          ...(inputValue.currentPlanCode && {
            currentPlanCode: inputValue.currentPlanCode,
          }),
          ...(inputValue.title && { title: inputValue.title }),
          ...(inputValue.existingCustomer && {
            existingCustomer: inputValue.existingCustomer,
          }),
          ...(inputValue.partyId && { partyId: inputValue.partyId }),
          ...(inputValue.birthdayMonth && {
            birthdayMonth: inputValue.birthdayMonth,
          }),
          ...(inputValue.mobile && { mobile: inputValue.mobile }),
          ...(inputValue.email && { email: inputValue.email }),
          ...(inputValue.languageForCommunication && {
            languageForCommunication: inputValue.languageForCommunication,
          }),
          ...(inputValue.communicationChannel && {
            communicationChannel: inputValue.communicationChannel,
          }),
          ...(inputValue.servAgentEmail && {
            servAgentEmail: inputValue.servAgentEmail,
          }),
          ...(inputValue.mobileAreaCode && {
            mobileAreaCode: inputValue.mobileAreaCode,
          }),
          ...(inputValue.picsIndicator && {
            picsIndicator: inputValue.picsIndicator,
          }),
          ...(inputValue.trCode && {
            trCode: inputValue.trCode,
          }),
          ...(inputValue.trNameEng && {
            trNameEng: inputValue.trNameEng,
          }),
        },
      });
    }
  };

  function exportToExcel() {
    if (originTotalChange > 15000) {
      sweetAlertService.errorMsg(
        t("errors.dataLimit"),
        t("errors.dataLimitText")
      );
    } else {
      const loadingSwal = SweetAlertService.showLoading(t("loginPage.loading"));

      let templateMapping;

      // Define template mappings based on PermcampaignTemplate
      if (PermcampaignTemplate === "kdollar") {
        templateMapping = getExportKdollarTemplate;
      } else if (PermcampaignTemplate === "ciconv") {
        templateMapping = getExportCiconvTemplate;
      } else if (PermcampaignTemplate === "bdelight") {
        templateMapping = getExportBdelightTemplate;
      }
      var campaignService = new CampaignService();
      campaignService
        .retrieveCampaignDetails(
          PermcampaignHeaderId,
          originTotalChange,
          Orderby,
          OrderSequence
        )
        .then((value) => {
          return value.data;
        })
        .then((data) => {
          return data.campaignDetailList;
        })
        .then((value) => {
          const mappedCampaignDetailList = value.map((detail) => {
            const mappedDetail = {};
            for (const title in templateMapping) {
              const column = templateMapping[title];
              if (
                column === "dateOfBirth" ||
                column === "firstPolicyIssueDate"
              ) {
                // Format the date values to remove the time portion
                const dateValue = detail[column]
                  ? detail[column].split("T")[0]
                  : "";
                mappedDetail[title] = dateValue;
              } else {
                mappedDetail[title] = detail[column];
              }
            }
            return mappedDetail;
          });

          const worksheet = XLSX.utils.json_to_sheet(mappedCampaignDetailList);
          const columnWidths = Object.keys(templateMapping).map((title) => ({
            wch: title.length + 2,
          }));
          worksheet["!cols"] = columnWidths;

          // Customize styles for header row
          const headerStyle = {
            font: { bold: true },
            alignment: { horizontal: "center" },
            fill: {
              type: "pattern",
              patternType: "solid",
              fgColor: { rgb: "CCCCCC" },
            },
          };

          // Apply styles to the header row
          for (let colIndex = 0; colIndex < columnWidths.length; colIndex++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            worksheet[cellRef].s = headerStyle;
          }

          // Create a new workbook and add the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Campaign Details");

          // Generate the Excel file buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          // Create a Blob from the buffer
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create a download link and trigger the download
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download =
            (savedLanguage === "en"
              ? campaignNameEng
              : savedLanguage === "cn"
              ? campaignNameCn
              : campaignNameHk) + ".xlsx";
          link.click();
        });
      SweetAlertService.close(loadingSwal);
    }
  }

  const onlyExport = async () => {
    if (pagination.totalNumberOfRecords > 15000) {
      sweetAlertService.errorMsg(
        t("errors.dataLimit"),
        t("errors.dataLimitText")
      );
    } else {
      const loadingSwal = SweetAlertService.showLoading(t("loginPage.loading"));

      let templateMapping;

      // Define template mappings based on PermcampaignTemplate
      if (PermcampaignTemplate === "kdollar") {
        templateMapping = getExportKdollarTemplate;
      } else if (PermcampaignTemplate === "ciconv") {
        templateMapping = getExportCiconvTemplate;
      } else if (PermcampaignTemplate === "bdelight") {
        templateMapping = getExportBdelightTemplate;
      }
      var campaignService = new CampaignService();
      await campaignService
        .onlyExport(PermcampaignHeaderId, inputValue, Orderby, OrderSequence)
        .then((value) => {
          return value.data;
        })
        .then((data) => {
          return data.campaignDetailList;
        })
        .then((value) => {
          const mappedCampaignDetailList = value.map((detail) => {
            const mappedDetail = {};
            for (const title in templateMapping) {
              const column = templateMapping[title];
              if (
                column === "dateOfBirth" ||
                column === "firstPolicyIssueDate"
              ) {
                // Format the date values to remove the time portion
                const dateValue = detail[column]
                  ? detail[column].split("T")[0]
                  : "";
                mappedDetail[title] = dateValue;
              } else {
                mappedDetail[title] = detail[column];
              }
            }
            return mappedDetail;
          });

          const worksheet = XLSX.utils.json_to_sheet(mappedCampaignDetailList);
          const columnWidths = Object.keys(templateMapping).map((title) => ({
            wch: savedLanguage === "en" ? title.length + 2 : title.length + 10,
          }));
          worksheet["!cols"] = columnWidths;

          // Customize styles for header row
          const headerStyle = {
            font: { bold: true },
            alignment: { horizontal: "center" },
            fill: {
              type: "pattern",
              patternType: "solid",
              fgColor: { rgb: "CCCCCC" },
            },
          };

          // Apply styles to the header row
          for (let colIndex = 0; colIndex < columnWidths.length; colIndex++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            worksheet[cellRef].s = headerStyle;
          }

          // Create a new workbook and add the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Campaign Details");

          // Generate the Excel file buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          // Create a Blob from the buffer
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create a download link and trigger the download
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download =
            (savedLanguage === "en"
              ? campaignNameEng
              : savedLanguage === "cn"
              ? campaignNameCn
              : campaignNameHk) + ".xlsx";
          link.click();
        });
      SweetAlertService.close(loadingSwal);
    }
  };

  const openMobile = () => {
    setShowModal(true);
  };

  const closeMobile = () => {
    setShowModal(false);
  };

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          {isMobileScreen ? (
            <div className="w-full ">
              <div className="flex">
                <h1 className="text-header font-bold text-ft-light w-3/4">
                  <a
                    href="/Campaign"
                    className="no-underline text-ft-light hover:text-ft">
                    {savedLanguage === "en"
                      ? campaignNameEng
                      : savedLanguage === "cn"
                      ? campaignNameCn
                      : campaignNameHk}
                  </a>
                </h1>
              </div>
              <div className="flex">
                <div className="w-full text-tableHeader">
                  <MultiSelect
                    options={
                      PermcampaignTemplate === "ciconv"
                        ? ciconvOptions
                        : PermcampaignTemplate === "kdollar"
                        ? kDollarOptions
                        : options
                    }
                    value={selected}
                    onChange={handleSelect}
                    labelledBy={"Select"}
                    isCreatable={false}
                    overrideStrings={overrideStrings}
                  />
                  {selected.map((option, index) => (
                    <div className="mt-2 " key={option.value}>
                      <label>{option.label}:</label>
                      <div className="flex text-tableHeader">
                        <input
                          className="rounded mr-2 text-tableHeader"
                          type={
                            option.value === "dateOfBirthFrom" ||
                            option.value === "dateOfBirthTo" ||
                            option.value === "firstPolicyIssueDateFrom" ||
                            option.value === "firstPolicyIssueDateTo"
                              ? "date"
                              : "text"
                          }
                          id={`input_${option.value}`}
                          defaultValue=""
                          onInput={(e) =>
                            handleInputChange(option, e.target.value)
                          }
                        />
                        <button
                          className="text-tableHeader bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                          onClick={() => handleCancel({ ...option, index })}>
                          {t("common.cancel")}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex">
                <div className="flex mt-3 text-tableHeader w-1/2 mr-5">
                  <a
                    onClick={() =>
                      handleCampaignChange(
                        PermcampaignHeaderId,
                        savedLanguage === "en"
                          ? campaignNameEng
                          : savedLanguage === "cn"
                          ? campaignNameCn
                          : campaignNameHk,
                        PermcampaignTemplate
                      )
                    }
                    className="no-underline text-center w-full bg-ft-light text-white py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                    {t("common.search")}
                  </a>
                </div>
                <div className="flex mt-3 text-tableHeader w-1/2 ">
                  <a
                    onClick={() =>
                      handleResetChange(
                        PermcampaignHeaderId,
                        savedLanguage === "en"
                          ? campaignNameEng
                          : savedLanguage === "cn"
                          ? campaignNameCn
                          : campaignNameHk,
                        PermcampaignTemplate
                      )
                    }
                    className="no-underline text-center w-full bg-white text-ft-light ring-ft-light ring-1 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft">
                    {t("common.reset")}
                  </a>
                </div>
              </div>
              {showModal ? (
                <>
                  <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                      {/*content*/}
                      <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <form
                          className="w-full px-12 my-5 "
                          onSubmit={handleSubmit}>
                          <div className="flex items-center justify-center w-full">
                            <label
                              htmlFor="dropzone-file"
                              className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                {fileName === "" ? (
                                  <>
                                    <svg
                                      aria-hidden="true"
                                      className="w-10 h-10 mb-3 text-gray-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                                    </svg>
                                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                      <span className="font-semibold">
                                        {t("common.browseImport")}
                                      </span>{" "}
                                      {t("campaignDetailsPage.dragDrop")}
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <div className={reArrange}>
                                      <div className="fi-content">
                                        {fileExtension}
                                      </div>
                                    </div>
                                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                      {" "}
                                      {fileName}
                                    </p>
                                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                      <span className="font-semibold">
                                        {t("common.browseReplace")}
                                      </span>{" "}
                                      {t("campaignDetailsPage.dragDrop")}
                                    </p>
                                  </>
                                )}
                              </div>
                              <input
                                id="dropzone-file"
                                type="file"
                                className="hidden"
                                onChange={handleUpload}
                                accept=".xlsx, .xls"
                              />{" "}
                            </label>
                          </div>

                          <div className="mt-4 text-center">
                            {PermcampaignTemplate === "ciconv" && (
                              <a
                                onClick={() =>
                                  downloadTemplate(
                                    "PDD_CIConversion_Template.xlsx"
                                  )
                                }
                                className="no-underline text-ft-light cursor-pointer hover:text-ft">
                                {t("common.download")}{" "}
                                {t("campaignPage.template.ciConv")}
                              </a>
                            )}
                            {PermcampaignTemplate === "kdollar" && (
                              <a
                                onClick={() =>
                                  downloadTemplate("CEE_KDollar_Template.xlsx")
                                }
                                className="no-underline text-ft-light cursor-pointer hover:text-ft">
                                {t("common.download")}{" "}
                                {t("campaignPage.template.kDollarDownload")}
                              </a>
                            )}
                          </div>
                          <div className="w-auto max-w-96 flex mt-4">
                            <button
                              type="submit"
                              className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                              {t("common.import")}
                            </button>
                            <button
                              type="button"
                              className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                              onClick={() => closeMobile()}>
                              {t("common.cancel")}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
              ) : null}

              <div className="flex mt-5">
                {functionList.includes(
                  String(functionConstants.CAMPAIGN_DETAILS_IMPORT)
                ) ? (
                  PermcampaignTemplate === "ciconv" ||
                  PermcampaignTemplate === "kdollar" ? (
                    <a
                      onClick={() => openMobile()}
                      className="no-underline text-tableHeader cursor-pointer w-1/3 mr-2 px-3 py-2 text-center bg-white text-ft-light ring-1 ring-ft-light rounded">
                      {t("common.import")}
                    </a>
                  ) : (
                    <>
                      <a
                        aria-disabled
                        className="no-underline text-tableHeader w-1/3 mr-2 px-3 py-2 text-center bg-gray-200 text-title ring-0 rounded">
                        {t("common.import")}
                      </a>
                    </>
                  )
                ) : (
                  <></>
                )}
                <a
                  onClick={() => onlyExport()}
                  className="no-underline text-tableHeader hover:bg-ft cursor-pointer w-1/3 mr-2 px-3 py-2 text-center text-white bg-ft-light  rounded">
                  {t("common.export")}
                </a>
                {PermcampaignTemplate === "bdelight" ? (
                  <></>
                ) : (
                  <a
                    onClick={() => exportToExcel()}
                    className="no-underline text-tableHeader hover:bg-ft cursor-pointer w-1/3 mr-2 px-3 py-2 text-center text-white bg-ft-light  rounded">
                    {t("common.exportAll")}
                  </a>
                )}
              </div>

              <div className="mt-4">
                <p className="text-tableHeader">
                  {t("common.showPerPage1")}
                  <select
                    id="countries"
                    aria-label="Select page size"
                    className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                    value={selectedValue}
                    onChange={handleChange}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  {t("common.showPerPage2")}
                </p>
              </div>
              <div className="items-center flex">
                <p className="text-tableHeader ">
                  {t("campaignPage.latestUpdated")}:
                  {PermcampaignTemplate === "bdelight"
                    ? latestupdateDate
                    : updateDate.slice(0, -6)}
                </p>
              </div>

              <div className="flex">
                {PermcampaignTemplate === "ciconv" ? (
                  <table className=" flex w-full bg-white">
                    <thead className="sm:w-2/5 w-2/5 text-white text-mobileLandingContent font-bold">
                      {campaigns.map((campaignMobileTitle) => {
                        return (
                          <tr
                            className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                            key={campaignMobileTitle.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <>
                                <th className=" h-12">
                                  {t("campaignDetailsPage.policyNumber")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.policyNumber")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.currentPlanCode")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.currentPlanCode")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.title")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.title")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.clientName")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.clientName")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.areaCode")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.areaCode")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.mobile")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.mobile")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 truncate ">
                                {t("campaignDetailsPage.email")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.email")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <th className="h-12 truncate ">
                                {t("campaignDetailsPage.picsStatus")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.picsStatus")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.existingCustomer")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.existingCustomer")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.custOrPartyId")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.custOrPartyId")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.regionCode")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.regionCode")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.brokerCode")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.brokerCode")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.brokerName")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.brokerName")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.agentCode")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.agentCode")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.agentName")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.agentName")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.brokerEmail")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.brokerEmail")}
                              </th>
                            )}
                            {/* <th className='h-6  mb-1'>Edit</th> */}
                          </tr>
                        );
                      })}
                    </thead>
                    <tbody className="sm:w-3/5 w-3/5 text-mobileLandingContent">
                      {campaigns.map((campaignMobileBody) => {
                        return (
                          <tr
                            className="flex flex-col border border-slate-300 mb-2"
                            key={campaignMobileBody.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 lineclamp2">
                                {campaignMobileBody.latestIssuedPolicy}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.latestIssuedPolicy}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.currentPlanCode}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.currentPlanCode}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.title}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.title}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.mobileAreaCode}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.mobileAreaCode}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.mobile}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.mobile}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.email}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.email}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.picsIndicator}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.picsIndicator}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.existingCustomer}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.existingCustomer}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.partyId}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.partyId}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.servAgentRegion}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.servAgentRegion}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.servAgentCode}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.servAgentCode}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.servAgentName}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.servAgentName}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.trCode}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.trCode}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.trNameEng}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.trNameEng}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.servAgentEmail}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.servAgentEmail}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <></>
                )}
                {PermcampaignTemplate === "kdollar" ? (
                  <table className=" flex w-full bg-white">
                    <thead className="sm:w-2/5 w-2/5 text-white text-mobileLandingContent font-bold">
                      {campaigns.map((campaignMobileTitle) => {
                        return (
                          <tr
                            className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                            key={campaignMobileTitle.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <>
                                <th className=" h-12">
                                  {t("campaignDetailsPage.partyId")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.partyId")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.policyownerNameHk")}{" "}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.policyownerNameHk")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.policyownerNameEng")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.policyownerNameEng")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.policyownerEmail")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.policyownerEmail")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.policyownerMobile")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.policyownerMobile")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t(
                                    "campaignDetailsPage.customerLanguagePreference"
                                  )}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t(
                                  "campaignDetailsPage.customerLanguagePreference"
                                )}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 ">
                                {t("campaignDetailsPage.referencePolicyNo.")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.referencePolicyNo.")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.customerCommunication")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.customerCommunication")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.kDollar")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.kDollar")}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t(
                                  "campaignDetailsPage.kDollarMembershipNumber"
                                )}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t(
                                  "campaignDetailsPage.kDollarMembershipNumber"
                                )}
                              </th>
                            )}

                            {isXsMobileScreen ? (
                              <th className="h-12 line-camp-2 ">
                                {t("campaignDetailsPage.redemptionStatus")}
                              </th>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.redemptionStatus")}
                              </th>
                            )}

                            {/* <th className='h-6  mb-1'>Edit</th> */}
                          </tr>
                        );
                      })}
                    </thead>
                    <tbody className="sm:w-3/5 w-3/5 text-mobileLandingContent">
                      {campaigns.map((campaignMobileBody) => {
                        return (
                          <tr
                            className="flex flex-col border border-slate-300 mb-2"
                            key={campaignMobileBody.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 lineclamp2">
                                {campaignMobileBody.partyId}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.partyId}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.clientFullNameChi}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.clientFullNameChi}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.email}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.email}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.mobile}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.mobile}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.languageForCommunication}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.languageForCommunication}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.latestIssuedPolicy}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.latestIssuedPolicy}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.communicationChannel}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.communicationChannel}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.kdollar}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.kdollar}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.kdollarMembership}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.kdollarMembership}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12">
                                <div className="lineclamp2 ">
                                  {campaignMobileBody.redemptionStatus}
                                </div>
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.redemptionStatus}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <></>
                )}

                {PermcampaignTemplate !== "ciconv" &&
                PermcampaignTemplate !== "kdollar" ? (
                  <table className=" flex w-full bg-white">
                    <thead className="sm:w-2/5 w-2/5 text-white text-mobileLandingContent font-bold">
                      {campaigns.map((campaignMobileTitle) => {
                        return (
                          <tr
                            className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                            key={campaignMobileTitle.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <>
                                <th className=" h-12">
                                  {t("campaignDetailsPage.clientNameEng")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.clientNameEng")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.clientNameHk")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.clientNameHk")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.dateOfBirth")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.dateOfBirth")}
                              </th>
                            )}

                            <th className=" h-6">
                              {t("campaignDetailsPage.birthdayMonth")}
                            </th>

                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t(
                                    "campaignDetailsPage.firstPolicyIssueDate"
                                  )}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.firstPolicyIssueDate")}
                              </th>
                            )}
                            {isXsMobileScreen ? (
                              <>
                                <th className="h-12 ">
                                  {t("campaignDetailsPage.latestIssuedPolicy")}
                                </th>
                              </>
                            ) : (
                              <th className="h-6 ">
                                {t("campaignDetailsPage.latestIssuedPolicy")}
                              </th>
                            )}

                            {ifa === "USER" ? (
                              <></>
                            ) : ifa === "ADMIN" ? (
                              <>
                                {isXsMobileScreen ? (
                                  <th className="h-12 truncate ">
                                    {t("campaignDetailsPage.companyName")}
                                  </th>
                                ) : (
                                  <th className="h-6 ">
                                    {t("campaignDetailsPage.companyName")}
                                  </th>
                                )}
                                {isXsMobileScreen ? (
                                  <>
                                    <th className="h-12 ">
                                      {t("campaignDetailsPage.agentCode")}
                                    </th>
                                  </>
                                ) : (
                                  <th className="h-6 ">
                                    {t("campaignDetailsPage.agentCode")}
                                  </th>
                                )}
                              </>
                            ) : (
                              <>
                                {isXsMobileScreen ? (
                                  <th className="h-12 truncate ">
                                    {t("campaignDetailsPage.companyName")}
                                  </th>
                                ) : (
                                  <th className="h-6 ">
                                    {t("campaignDetailsPage.companyName")}
                                  </th>
                                )}
                                {isXsMobileScreen ? (
                                  <>
                                    <th className="h-12 ">
                                      {t("campaignDetailsPage.agentCode")}
                                    </th>
                                  </>
                                ) : (
                                  <th className="h-6 ">
                                    {t("campaignDetailsPage.agentCode")}
                                  </th>
                                )}

                                <th className="h-6 mb-1">
                                  {t("campaignDetailsPage.agentName")}
                                </th>
                                {/* <th className='h-6  mb-1'>Edit</th> */}
                              </>
                            )}
                          </tr>
                        );
                      })}
                    </thead>
                    <tbody className="sm:w-3/5 w-3/5 text-mobileLandingContent">
                      {campaigns.map((campaignMobileBody) => {
                        const dateOfBirth = new Date(
                          campaignMobileBody.dateOfBirth
                        );
                        const firstPolicyIssueDate = new Date(
                          campaignMobileBody.firstPolicyIssueDate
                        );
                        const formattedDateOfBirth = dateOfBirth
                          .toISOString()
                          .slice(0, 10);
                        const formattedFirstPolicyIssueDate =
                          firstPolicyIssueDate.toISOString().slice(0, 10);

                        return (
                          <tr
                            className="flex flex-col border border-slate-300 mb-2"
                            key={campaignMobileBody.campaignDetailId}>
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 lineclamp2">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.clientFullNameEng}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.clientFullNameChi}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.clientFullNameChi}
                              </td>
                            )}

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {formattedDateOfBirth}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {formattedDateOfBirth}
                              </td>
                            )}

                            <td className="pl-3 pr-3 h-6 truncate">
                              {campaignMobileBody.birthdayMonth}
                            </td>

                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {formattedFirstPolicyIssueDate}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {formattedFirstPolicyIssueDate}
                              </td>
                            )}
                            {isXsMobileScreen ? (
                              <td className="pl-3 pr-3 h-12 break-all">
                                {campaignMobileBody.latestIssuedPolicy}
                              </td>
                            ) : (
                              <td className="pl-3 pr-3 h-6 truncate">
                                {campaignMobileBody.latestIssuedPolicy}
                              </td>
                            )}

                            {ifa === "USER" ? (
                              <></>
                            ) : ifa === "ADMIN" ? (
                              <>
                                {isXsMobileScreen ? (
                                  <td className="pl-3 pr-3 h-12">
                                    <div className="lineclamp2 ">
                                      {campaignMobileBody.servAgentName}
                                    </div>
                                  </td>
                                ) : (
                                  <td className="pl-3 pr-3 h-6 truncate">
                                    {campaignMobileBody.servAgentName}
                                  </td>
                                )}
                                {isXsMobileScreen ? (
                                  <td className="pl-3 pr-3 h-12 break-all">
                                    {campaignMobileBody.trCode}
                                  </td>
                                ) : (
                                  <td className="pl-3 pr-3 h-6 truncate">
                                    {campaignMobileBody.trCode}
                                  </td>
                                )}
                              </>
                            ) : (
                              <>
                                {isXsMobileScreen ? (
                                  <td className="pl-3 pr-3 h-12">
                                    <div className="lineclamp2 ">
                                      {campaignMobileBody.servAgentName}
                                    </div>
                                  </td>
                                ) : (
                                  <td className="pl-3 pr-3 h-6 truncate">
                                    {campaignMobileBody.servAgentName}
                                  </td>
                                )}
                                {isXsMobileScreen ? (
                                  <td className="pl-3 pr-3 h-12 break-all">
                                    {campaignMobileBody.trCode}
                                  </td>
                                ) : (
                                  <td className="pl-3 pr-3 h-6 truncate">
                                    {campaignMobileBody.trCode}
                                  </td>
                                )}

                                <td className="pl-3 pr-3 h-6 truncate mb-1">
                                  {campaignMobileBody.trNameEng}
                                </td>
                              </>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <></>
                )}
              </div>
              <div className="flex flex-col items-center  text-mobileLandingContent">
                <div>
                  {pagination.totalNumberOfRecords === 0 ? (
                    <p className="text-sm text-gray-700">
                      {t("common.noRecord")}
                    </p>
                  ) : (
                    <p className="text-sm text-gray-700">
                      {t("common.showPage1")}
                      <span className="font-medium"> {preResult}</span>{" "}
                      {t("common.showPage2")}{" "}
                      <span className="font-medium">{nextResult}</span>{" "}
                      {t("common.showPage3")}{" "}
                      <span className="font-medium">
                        {pagination.totalNumberOfRecords}
                      </span>{" "}
                      {t("common.showPage4")}
                    </p>
                  )}
                </div>
                {pagination && pagination.totalNumberOfRecords > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      page={parseInt(pagination.pageNumber) + 1}
                      shape={"circular"}
                      count={
                        pagination.totalNumberOfRecords &&
                        pagination.pageSize &&
                        !isNaN(pagination.totalNumberOfRecords) &&
                        !isNaN(pagination.pageSize)
                          ? Math.ceil(
                              pagination.totalNumberOfRecords /
                                pagination.pageSize
                            )
                          : 0
                      }
                      onChange={(e, value) => handlePageChange(value)}
                    />
                  </Stack>
                )}
              </div>
              <ScrollToTopButton />
            </div>
          ) : (
            <div className="w-deflaut px-2">
              <div className="flex justify-content-between align-items-center my-3">
                <p className="text-header text-ft-light font-bold">
                  <a
                    href="/Campaign"
                    className="no-underline text-ft-light hover:text-ft">
                    {savedLanguage === "en"
                      ? campaignNameEng
                      : savedLanguage === "cn"
                      ? campaignNameCn
                      : campaignNameHk}
                  </a>
                </p>
              </div>

              <div className="w-full flex justify-center mb-4 text-tableHeader">
                <div className="w-2/3 mr-5">
                  <div>
                    <MultiSelect
                      options={
                        PermcampaignTemplate === "ciconv"
                          ? ciconvOptions
                          : PermcampaignTemplate === "kdollar"
                          ? kDollarOptions
                          : options
                      }
                      value={selected}
                      onChange={handleSelect}
                      labelledBy={"Select"}
                      isCreatable={false}
                      overrideStrings={overrideStrings}
                    />
                    {selected.map((option, index) => (
                      <div className="mt-2 " key={option.value}>
                        <label>{option.label}:</label>
                        <div className="flex">
                          <input
                            className="rounded mr-2 text-tableHeader"
                            type={
                              option.value === "dateOfBirthFrom" ||
                              option.value === "dateOfBirthTo" ||
                              option.value === "firstPolicyIssueDateFrom" ||
                              option.value === "firstPolicyIssueDateTo"
                                ? "date"
                                : "text"
                            }
                            id={`input_${option.value}`}
                            defaultValue=""
                            onInput={(e) =>
                              handleInputChange(option, e.target.value)
                            }
                          />
                          <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                            onClick={() => handleCancel({ ...option, index })}>
                            {t("common.cancel")}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="w-1/3 flex flex-col justify-between mt-2">
                  <div className="h-1/2 flex">
                    <div className="mr-5">
                      <a
                        onClick={() =>
                          handleCampaignChange(
                            PermcampaignHeaderId,
                            savedLanguage === "en"
                              ? campaignNameEng
                              : savedLanguage === "cn"
                              ? campaignNameCn
                              : campaignNameHk,
                            PermcampaignTemplate
                          )
                        }
                        className="no-underline bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft cursor-pointer">
                        {t("common.search")}
                      </a>
                    </div>
                    <div className="">
                      <a
                        onClick={() =>
                          handleResetChange(
                            PermcampaignHeaderId,
                            savedLanguage === "en"
                              ? campaignNameEng
                              : savedLanguage === "cn"
                              ? campaignNameCn
                              : campaignNameHk,
                            PermcampaignTemplate
                          )
                        }
                        className="no-underline bg-white text-ft-light ring-ft-light ring-1 px-3 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft cursor-pointer">
                        {t("common.reset")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between">
                <div></div>
                <div>
                  {functionList.includes(
                    String(functionConstants.CAMPAIGN_DETAILS_IMPORT)
                  ) ? (
                    PermcampaignTemplate === "ciconv" ||
                    PermcampaignTemplate === "kdollar" ? (
                      <a
                        onClick={openModal}
                        className="no-underline hover:bg-ft hover:text-white text-tableHeader cursor-pointer mr-2 px-3 py-2 bg-white text-ft-light ring-1 ring-ft-light rounded">
                        {t("common.import")}
                      </a>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                  <a
                    onClick={() => onlyExport()}
                    className="no-underline hover:bg-ft text-tableHeader mr-2 px-3 py-2 text-white bg-ft-light  rounded cursor-pointer">
                    {t("common.export")}
                  </a>
                  {PermcampaignTemplate === "bdelight" ? (
                    <></>
                  ) : (
                    <a
                      onClick={() => exportToExcel()}
                      className="no-underline hover:bg-ft text-tableHeader mr-2 px-3 py-2 text-white bg-ft-light rounded cursor-pointer">
                      {t("common.exportAll")}
                    </a>
                  )}
                </div>
              </div>
              <div className="mt-3 flex justify-between">
                <div className="mr-5">
                  <p className="text-content">
                    {t("common.showPerPage1")}
                    <select
                      id="countries"
                      aria-label="Select page size"
                      className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                      value={selectedValue}
                      onChange={handleChange}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    {t("common.showPerPage2")}
                  </p>
                </div>
                <div className="items-center flex">
                  <p className="text-content ">
                    {t("campaignPage.latestUpdated")}:
                    {PermcampaignTemplate === "bdelight"
                      ? latestupdateDate
                      : updateDate.slice(0, -6)}
                  </p>
                </div>

                <Modal
                  open={modalIsOpen}
                  onClose={closeModal}
                  component="form"
                  onSubmit={handleSubmit}>
                  <div className="flex items-center justify-center w-96 ">
                    <label
                      htmlFor="dropzone-file"
                      className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        {fileName === "" ? (
                          <>
                            <svg
                              aria-hidden="true"
                              className="w-10 h-10 mb-3 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                {t("common.browseImport")}
                              </span>{" "}
                              {t("campaignDetailsPage.dragDrop")}
                            </p>
                          </>
                        ) : (
                          <>
                            <div className={reArrange}>
                              <div className="fi-content">{fileExtension}</div>
                            </div>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              {" "}
                              {fileName}
                            </p>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                {t("common.browseReplace")}
                              </span>{" "}
                              {t("campaignDetailsPage.dragDrop")}
                            </p>
                          </>
                        )}
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        onChange={handleUpload}
                        accept=".xlsx, .xls"
                      />{" "}
                    </label>
                  </div>

                  <div className="mt-4 text-center">
                    {PermcampaignTemplate === "ciconv" && (
                      <a
                        onClick={() =>
                          downloadTemplate("PDD_CIConversion_Template.xlsx")
                        }
                        className="no-underline text-ft-light cursor-pointer hover:text-ft">
                        {t("common.download")}{" "}
                        {t("campaignPage.template.ciConv")}
                      </a>
                    )}
                    {PermcampaignTemplate === "kdollar" && (
                      <a
                        onClick={() =>
                          downloadTemplate("CEE_KDollar_Template.xlsx")
                        }
                        className="no-underline text-ft-light cursor-pointer hover:text-ft">
                        {t("common.download")}{" "}
                        {t("campaignPage.template.kDollar")}
                      </a>
                    )}
                  </div>
                  <div className="w-auto max-w-96 flex mt-4">
                    <button
                      type="submit"
                      className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                      {t("common.import")}
                    </button>
                    <button
                      type="button"
                      className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                      onClick={closeModal}>
                      {t("common.cancel")}
                    </button>
                  </div>
                </Modal>
              </div>
              <div className="w-table flex ">
                <div className="overflow-x w-full flex">
                  {PermcampaignTemplate === "ciconv" ? (
                    <table className="table-fixed overflow-scroll w-full block">
                      <thead className="text-tableHeader">
                        <tr className="border border-slate-300 ">
                          <th
                            className=" hover:text-ft-light cursor-pointer pl-5 h-8"
                            onClick={() => handleOrder("latestIssuedPolicy")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.policyNumber")}
                              <Icon src="orderBy" />
                            </div>
                          </th>

                          <th
                            className=" hover:text-ft-light cursor-pointer h-8 "
                            onClick={() => handleOrder("currentPlanCode")}>
                            <div className="inline-block h-6 w-48">
                              {t("campaignDetailsPage.currentPlanCode")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("title")}>
                            <div className="inline-block h-6 w-20">
                              {t("campaignDetailsPage.title")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("clientFullNameEng")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.clientName")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("mobileAreaCode")}>
                            <div className="inline-block h-6 w-24">
                              {t("campaignDetailsPage.areaCode")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("mobile")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.mobile")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("email")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.email")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("picsIndicator")}>
                            <div className="inline-block h-6 w-32">
                              {t("campaignDetailsPage.picsStatus")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("existingCustomer")}>
                            <div className="inline-block h-6 w-36">
                              {t("campaignDetailsPage.existingCustomer")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("partyId")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.custOrPartyId")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("servAgentRegion")}>
                            <div className="inline-block h-6 w-36">
                              {t("campaignDetailsPage.regionCode")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("servAgentCode")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.brokerCode")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("servAgentName")}>
                            <div className="inline-block h-6 w-48">
                              {t("campaignDetailsPage.brokerName")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("trCode")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.agentCode")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("trNameEng")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.agentName")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("servAgentEmail")}>
                            <div className="inline-block h-6 w-48">
                              {t("campaignDetailsPage.brokerEmail")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          {/* <th className=' h-8'>
              <div className='inline-block h-6 w-16'>
                Edit
                 </div>
            </th> */}
                        </tr>
                      </thead>
                      <tbody className="text-left text-content">
                        {campaigns.map((campaign) => {
                          return (
                            <tr
                              className="border border-slate-300 h-16"
                              key={campaign.campaignDetailId}>
                              <td className="">
                                <div className="w-52 lineclamp2 pl-5 items-center">
                                  {campaign.latestIssuedPolicy}
                                </div>
                              </td>
                              <td className="">
                                <div className="w-48 break-all  items-center align-middle">
                                  {campaign.currentPlanCode}
                                </div>
                              </td>
                              <td className="">{campaign.title}</td>
                              <td className="">{campaign.clientFullNameEng}</td>
                              <td className="">{campaign.mobileAreaCode}</td>
                              <td className="">{campaign.mobile}</td>
                              <td className="">{campaign.email}</td>
                              <td className="">{campaign.picsIndicator}</td>
                              <td className="">{campaign.existingCustomer}</td>
                              <td className="">{campaign.partyId}</td>
                              <td className="">{campaign.servAgentRegion}</td>
                              <td className="">{campaign.servAgentCode}</td>
                              <td className="">{campaign.servAgentName}</td>
                              <td className="">{campaign.trCode}</td>
                              <td className="">{campaign.trNameEng}</td>
                              <td className="">{campaign.servAgentEmail}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <></>
                  )}
                  {PermcampaignTemplate === "kdollar" ? (
                    <table className="table-fixed overflow-scroll w-full block">
                      <thead className="text-tableHeader">
                        <tr className="border border-slate-300 ">
                          <th
                            className=" hover:text-ft-light cursor-pointer pl-5 h-8"
                            onClick={() => handleOrder("partyId")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.partyId")}
                              <Icon src="orderBy" />
                            </div>
                          </th>

                          <th
                            className=" hover:text-ft-light cursor-pointer h-8 "
                            onClick={() => handleOrder("clientFullNameChi")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.policyownerNameHk")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("clientFullNameEng")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.policyownerNameEng")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("email")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.policyownerEmail")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("mobile")}>
                            <div className="inline-block h-6 w-48">
                              {t("campaignDetailsPage.policyownerMobile")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() =>
                              handleOrder("languageForCommunication")
                            }>
                            <div className="inline-block h-6 w-56">
                              {t(
                                "campaignDetailsPage.customerLanguagePreference"
                              )}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("latestIssuedPolicy")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.referencePolicyNo.")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("communicationChannel")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.customerCommunication")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("kDollar")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.kDollar")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("kDollarMembership")}>
                            <div className="inline-block h-6 w-64">
                              {t("campaignDetailsPage.kDollarMembershipNumber")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("redemptionStatus")}>
                            <div className="inline-block h-6 w-44">
                              {t("campaignDetailsPage.redemptionStatus")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-left text-content">
                        {campaigns.map((campaign) => {
                          return (
                            <tr
                              className="border border-slate-300 h-16"
                              key={campaign.campaignDetailId}>
                              <td className="">
                                <div className="w-52 lineclamp2 pl-5 items-center">
                                  {campaign.partyId}
                                </div>
                              </td>
                              <td className="">
                                <div className="">
                                  {campaign.clientFullNameChi}
                                </div>
                              </td>
                              <td className="">
                                <div className="w-48 break-all  items-center align-middle">
                                  {campaign.clientFullNameEng}
                                </div>
                              </td>
                              <td className="">{campaign.email}</td>
                              <td className="">{campaign.mobile}</td>
                              <td className="">
                                {campaign.languageForCommunication}
                              </td>
                              <td className="">
                                {campaign.latestIssuedPolicy}
                              </td>
                              <td className="">
                                {campaign.communicationChannel}
                              </td>
                              <td className="">{campaign.kdollar}</td>
                              <td className="">{campaign.kdollarMembership}</td>
                              <td className="">{campaign.redemptionStatus}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <></>
                  )}
                  {PermcampaignTemplate !== "ciconv" &&
                  PermcampaignTemplate !== "kdollar" ? (
                    <table className="table-fixed overflow-scroll w-fit block max-w-full">
                      <thead className="text-tableHeader">
                        <tr className="border border-slate-300 ">
                          <th
                            className=" hover:text-ft-light cursor-pointer pl-5 h-8"
                            onClick={() => handleOrder("clientFullNameEng")}>
                            <div className="inline-block h-6 w-56">
                              {t("campaignDetailsPage.clientNameEng")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8 "
                            onClick={() => handleOrder("clientFullNameChi")}>
                            <div className="inline-block h-6 w-comAns">
                              {t("campaignDetailsPage.clientNameHk")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8 "
                            onClick={() => handleOrder("dateOfBirth")}>
                            <div className="inline-block h-6 w-tableRemark">
                              {t("campaignDetailsPage.dateOfBirth")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8 "
                            onClick={() => handleOrder("birthdayMonth")}>
                            <div className="inline-block h-6 w-36">
                              {t("campaignDetailsPage.birthdayMonth")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("firstPolicyIssueDate")}>
                            <div className="inline-block h-6 w-tableCode">
                              {t("campaignDetailsPage.firstPolicyIssueDate")}
                              <Icon src="orderBy" />
                            </div>
                          </th>
                          <th
                            className=" hover:text-ft-light cursor-pointer h-8"
                            onClick={() => handleOrder("latestIssuedPolicy")}>
                            <div className="inline-block h-6 w-tableCode">
                              {t("campaignDetailsPage.latestIssuedPolicy")}
                              <Icon src="orderBy" />
                            </div>
                          </th>

                          {ifa === "USER" ? (
                            <></>
                          ) : (
                            <>
                              {ifa === "ADMIN" ? (
                                <></>
                              ) : (
                                <>
                                  <th
                                    className=" hover:text-ft-light cursor-pointer h-8"
                                    onClick={() =>
                                      handleOrder("servAgentName")
                                    }>
                                    <div className="inline-block h-6 w-44">
                                      {t("campaignDetailsPage.companyName")}
                                      <Icon src="orderBy" />
                                    </div>
                                  </th>
                                </>
                              )}
                              <th
                                className=" hover:text-ft-light cursor-pointer h-8"
                                onClick={() => handleOrder("trCode")}>
                                <div className="inline-block h-6 w-48">
                                  {t("campaignDetailsPage.agentCode")}
                                  <Icon src="orderBy" />
                                </div>
                              </th>

                              <th
                                className=" hover:text-ft-light cursor-pointer h-8"
                                onClick={() => handleOrder("trNameEng")}>
                                <div className="inline-block h-6 w-48">
                                  {t("campaignDetailsPage.agentName")}
                                  <Icon src="orderBy" />
                                </div>
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody className="text-left text-content">
                        {campaigns.map((campaign) => {
                          const dateOfBirth = new Date(campaign.dateOfBirth);
                          const firstPolicyIssueDate = new Date(
                            campaign.firstPolicyIssueDate
                          );
                          const formattedDateOfBirth = dateOfBirth
                            .toISOString()
                            .slice(0, 10);
                          const formattedFirstPolicyIssueDate =
                            firstPolicyIssueDate.toISOString().slice(0, 10);

                          if (campaign.remark === "NULL") {
                            campaign.remark = "";
                          }

                          if (campaign.thumbnailDocID === 0) {
                            campaign.thumbnailDocID = "";
                          }

                          return (
                            <tr
                              className="border border-slate-300 h-16"
                              key={campaign.campaignDetailId}>
                              <td className="">
                                <div className="w-52 lineclamp2 pl-5 items-center">
                                  {campaign.clientFullNameEng}
                                </div>
                              </td>
                              <td className="">
                                <div className="w-comAns break-all  items-center align-middle">
                                  {campaign.clientFullNameChi}
                                </div>
                              </td>
                              <td className="tableDate">
                                {formattedDateOfBirth}
                              </td>
                              <td className="tableDate pl-5">
                                {campaign.birthdayMonth}
                              </td>
                              <td className="tableCode">
                                {formattedFirstPolicyIssueDate}
                              </td>
                              <td className="tableCode">
                                {campaign.latestIssuedPolicy}
                              </td>
                              {ifa === "USER" ? (
                                <></>
                              ) : ifa === "ADMIN" ? (
                                <>
                                  <td className="">{campaign.trCode}</td>

                                  <td className="">{campaign.trNameEng}</td>
                                </>
                              ) : (
                                <>
                                  <td className="">
                                    <div
                                      data-tooltip-target="tooltip-default"
                                      className="w-40 lineclamp2">
                                      {campaign.servAgentName}
                                    </div>
                                  </td>
                                  <td className="">{campaign.trCode}</td>

                                  <td className="">{campaign.trNameEng}</td>
                                </>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-between px-4 py-3 md:px-6">
                <div className="hidden md:flex md:flex-1 md:items-center md:justify-between">
                  <div className="text-content">
                    {pagination.totalNumberOfRecords === 0 ? (
                      <p className="text-sm text-gray-700">
                        {t("common.noRecord")}
                      </p>
                    ) : (
                      <p className="text-sm text-gray-700">
                        {t("common.showPage1")}
                        <span className="font-medium"> {preResult}</span>{" "}
                        {t("common.showPage2")}{" "}
                        <span className="font-medium">{nextResult}</span>{" "}
                        {t("common.showPage3")}{" "}
                        <span className="font-medium">
                          {pagination.totalNumberOfRecords}
                        </span>{" "}
                        {t("common.showPage4")}
                      </p>
                    )}
                  </div>

                  <div>
                    {pagination && pagination.totalNumberOfRecords > 0 && (
                      <Stack spacing={2}>
                        <Pagination
                          page={parseInt(pagination.pageNumber) + 1}
                          shape={"circular"}
                          count={
                            pagination.totalNumberOfRecords &&
                            pagination.pageSize &&
                            !isNaN(pagination.totalNumberOfRecords) &&
                            !isNaN(pagination.pageSize)
                              ? Math.ceil(
                                  pagination.totalNumberOfRecords /
                                    pagination.pageSize
                                )
                              : 0
                          }
                          onChange={(e, value) => handlePageChange(value)}
                        />
                      </Stack>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default CampaignDetailList;
